import React from 'react';
import classNames from 'classnames';
import forwardRefComponent from 'app/common/lib/util/forward-ref-component';
import Icon, { IconColor, IconName } from 'app/common/components/controls/icon';
import styles from './BoardHeaderButton.less';
import { useFocusRing } from '@trello/a11y';

interface BoardHeaderButtonProps {
  backgroundBrightness?: 'dark' | 'light';
  icon?: IconName;
  iconColor?: IconColor;
  onClick: React.MouseEventHandler;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  text?: string;
}

export const BoardHeaderButton = forwardRefComponent<
  HTMLButtonElement,
  BoardHeaderButtonProps
>(
  'BoardHeaderButton',
  (
    {
      backgroundBrightness,
      icon,
      iconColor,
      onClick,
      onMouseEnter,
      onMouseLeave,
      text,
    },
    ref,
  ) => {
    const [hasFocusRing, mouseEvents] = useFocusRing({
      onMouseEnter,
      onMouseLeave,
    });

    return (
      <button
        className={classNames(
          styles.boardHeaderButton,
          hasFocusRing && styles.focusRing,
          backgroundBrightness && styles[backgroundBrightness],
        )}
        ref={ref}
        onClick={onClick}
        {...mouseEvents}
      >
        {icon && (
          <Icon
            color={iconColor}
            medium
            name={icon}
            className={classNames(
              styles.headerButtonIcon,
              backgroundBrightness && styles[backgroundBrightness],
            )}
          />
        )}
        {text && (
          <span
            className={classNames(
              styles.text,
              backgroundBrightness && styles[backgroundBrightness],
            )}
          >
            {text}
          </span>
        )}
      </button>
    );
  },
);
